<template>
  <div>
    <b-form-select
      v-if="requiredField"
      class="select-field"
      :options="optionsBoolean"
      v-model="model"
    >
    </b-form-select>
    <!-- <div>fieldType: {{fieldType}}</div> -->
  </div>
</template>
<script>
export default {
  name: "BaseRequiredDropdown",
  props: {
    value: Boolean,
    fieldType: Number,
  },
  data() {
    return {
      optionsBoolean: [
        { value: null, text: "Usar padrão" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    requiredField() {
      if (!this.fieldType) return true;
      if (this.fieldType == 8) return false;
      if (this.fieldType == 9) return false;
      return true;
    },
  },
  methods: {
  },
  //   watch: {
  //     timerAutoRefresh() {
  //       if (this.eventTimer.eventTimerSeconds != this.timerAutoRefresh) {
  //         this.eventTimer.eventTimerSeconds = this.timerAutoRefresh;
  //         this.saveEventTimer();
  //       }
  //     },
  //   },
};
</script>